import { ActivitySpinnerSize, ActivitySpinnerWidget, ButtonType, ButtonWidget, TabStyles } from "@tableau/widgets";
import * as React from 'react';
import { Messages } from '../../gen-src/Localize';
import { SvgPrepDetailsChangesEdit } from '../../gen-src/icons/PrepDetailsChangesEdit';
import { InlineEditorLogic_EditMode, InlineEditorLogic_ReadonlyMode } from './useInlineEditor';

/** A button widget that calls enterEditMode when clicked. Hidden if canEdit is false. */
export function InlineEditorEditButton(
  props: InlineEditorLogic_ReadonlyMode & { editButtonLabel: string }
): React.ReactElement {

  const { canEdit, enterEditMode, editButtonLabel, editButtonRef } = props;

  return (
    <ButtonWidget
      style={canEdit ? undefined : { visibility: 'hidden' }}
      disabled={!canEdit}
      buttonType={ButtonType.Icon}
      handleClick={enterEditMode}
      title={editButtonLabel}
      buttonRef={editButtonRef}
      testId="inline-editor-icon"
    >
      <SvgPrepDetailsChangesEdit />
    </ButtonWidget>
  );
}

/**
 * The default save button component, calls onSave with the current editor state when clicked.
 * Disabled when canSave returns false.
 */
export function InlineEditorSaveButton<S>(props: InlineEditorLogic_EditMode<S>): React.ReactElement {

  const { canSaveThisEditorState, isActionBusy, startSave } = props;

  return (
    <ButtonWidget
      disabled={!canSaveThisEditorState || isActionBusy}
      buttonType={ButtonType.Primary}
      handleClick={startSave}
      title={Messages.Save()}
      testId="inline-editor-save"
    >
      {isActionBusy ? (
        <div style={{ marginTop: TabStyles.Spacing.SmallSpace }}>
          <ActivitySpinnerWidget onDarkBackground={true} spinnerSize={ActivitySpinnerSize.Small} testId="inline-editor-saving" />
        </div>
      ) : (
        <span>{Messages.Save()}</span>
      )}
    </ButtonWidget>
  );
}

/** The default cancel button component. When clicked, will discard the editor state and leave edit mode. */
export function InlineEditorCancelButton<S>(props: InlineEditorLogic_EditMode<S>): React.ReactElement {

  const { isActionBusy, cancelEditing } = props;

  return (
    <ButtonWidget
      disabled={isActionBusy}
      buttonType={ButtonType.Outline}
      handleClick={cancelEditing}
      title={Messages.Cancel()}
      testId="inline-editor-cancel"
    >
      {Messages.Cancel()}
    </ButtonWidget>
  );
}
